export default __webpack_public_path__ + "940cae073c32966576297f236fc25c40.jpg";